<template>
	<div class="tab">
		<!-- 角色成员部分 -->
		<div class="yx-form-wrap mt-10 roleTab" v-if="tabIndex == 0">
			<template v-if="!isAdmin">
				<el-form inline>
					<el-form-item label="用户名称" class="mr-38">
						<el-input v-model="form.nickname" clearable placeholder="请输入" style="width: 240px"></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="form.mobile" clearable placeholder="请输入" style="width: 240px"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getList" plain>搜索</el-button>
						<el-button @click="onClear">重置</el-button>
					</el-form-item>
				</el-form>
				<el-button class="mt-24 mb-24" type="primary" @click="addmember" plain v-auth="['system:permission:assign-user-role']">新增成员</el-button>
			</template>
		</div>
		<!-- 角色权限部分 -->
		<div v-else>
			<div class="flex-row-align-center">
				<span class="font-h4-medium">数据权限</span>
				<span class="ml-2">
					<explain content="按达人跟进关系判断归属时，无法选择该选项" placement="bottom" size="12"></explain>
				</span>
			</div>
			<div class="mt-20 power font-h4-regular">
				<p>权限</p>
				<p>{{ dataPower }}</p>
			</div>
			<div class="flex-row-align-center mt-20">
				<span class="font-h4-medium">菜单权限</span>
				<span class="ml-2">
					<explain content="按达人跟进关系判断归属时，无法选择该选项" placement="bottom" size="12"></explain>
				</span>
			</div>
			<div class="mt-20 mr-20">
				<el-table :data="tableData" style="width: 100%" :header-cell-style="tableHead">
					<el-table-column prop="name" label="菜单功能" width="180"></el-table-column>
					<el-table-column label="权限">
						<template slot-scope="scope">
							<img src="@/assets/public/success.png" style="width: 14px" alt="" />
							<span class="powerText">{{ scope.row.power }}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<Add-member-draw ref="addMemberDraw" @refresh="refresh"></Add-member-draw>
	</div>
</template>

<script>
import Explain from '@/components/common/explain';
import AddMemberDraw from '../addMemberDraw/addMemberDraw.vue';
import { getRoleMenuPower, getAllMenuPower } from '@/api/teamManage';
const { checkAuth } = HOC;
export default {
	data() {
		return {
			form: {
				nickname: '',
				mobile: '',
				pageNo: 1,
				pageSize: 10,
			},
			tableHead: {
				background: '#ebedf5',
				color: '#4e596a',
			},
			tableData: [],
			resultArr: [],
			// 数据字典
			dataScopeDict: this.getDictDatas(this.DICT_TYPE.SYSTEM_DATA_SCOPE),
		};
	},
	computed: {
		filterColumns() {
			return this.isAdmin ? this.superColumns : this.columns;
		},
		dataPower() {
			return this.dataScopeDict.find(item => +item.value === this.dataScope)?.label || '全部权限';
		},
		dataScope() {
			return this.roleObj?.dataScope;
		},
	},
	props: {
		roleObj: {
			type: Object,
			default: () => ({}),
		},
		memberList: {
			type: Array,
			default: () => [],
		},
		tabIndex: {
			type: [String, Number],
			default: 0,
		},
		activeIndex: {
			type: [String, Number],
			default: 0,
		},
		isAdmin: {
			type: Boolean,
			default: false,
		},
		total: {
			type: [String, Number],
			default: 0,
		},
	},
	components: { Explain, AddMemberDraw },
	mounted() {},
	methods: {
		getList() {
			this.form.pageNo = 1;
			this.$emit('getRoleMember', this.form);
		},
		addmember: checkAuth(function () {
			const { activeIndex } = this;
			this.$refs.addMemberDraw.show(activeIndex);
		}, 'system:permission:assign-user-role'),
		onClear() {
			this.reset();
			this.getList();
		},
		reset() {
			this.form = {
				nickname: '',
				mobile: '',
				pageNo: 1,
				pageSize: 10,
			};
		},
		async getRoleMenuPower() {
			this.resultArr = [];
			const data = await getRoleMenuPower({ roleIds: [this.activeIndex] }); //获取对应的id  到时候可以注释换上面的
			let treeList = data;
			let menuList = await getAllMenuPower(); //获取所有的权限列表
			let arr = [];
			let finalArr = [];
			menuList = this.arrayToTree(menuList, 0); // 到时候可以注释换上面的
			menuList.forEach(item => {
				this.resultArr.push({ ...item, childrens: [] });
				this.treeToArray(item);
			});
			this.resultArr.forEach(item => {
				arr.push({ name: item.name, childrens: [] });
				item.childrens.forEach(v => {
					if (treeList.includes(v.id)) {
						arr[arr.length - 1].childrens.push(v.name);
					} else {
						arr[arr.length - 1].flage = true; //如果不存在flage,那么代表所有权限
					}
				});
			});
			arr.forEach(item => {
				if (!item.flage) {
					finalArr.push({ name: item.name, power: '所有权限' });
				} else {
					finalArr.push({ name: item.name, power: item.childrens.join('、') });
				}
			});
			this.tableData = finalArr.filter(item => {
				return item.power != '' ? item : '';
			});
		},
		//转换一维数组成树形数组
		arrayToTree(data, pid) {
			return data.filter(item => item.parentId === pid).map(item => ({ ...item, children: this.arrayToTree(data, item.id) }));
		},
		//多级树形结构转成二级树形结构
		treeToArray(obj) {
			if (obj.children.length > 0) {
				obj.children.forEach(v => {
					this.resultArr[this.resultArr.length - 1].childrens.push(v);
					if (v.children.length > 0) return this.treeToArray(v);
				});
			} else {
				this.resultArr[this.resultArr.length - 1].childrens.push(obj);
			}
		},
		refresh() {
			this.$emit('refresh');
		},
	},
};
</script>
<style lang="less" scoped>
.roleTab {
	border-bottom: none;
}

.power {
	margin-right: 20px;
	border: 1px solid #ebedf5;

	> p {
		height: 50px;
		line-height: 50px;
		padding-left: 16px;
	}

	& p:first-child {
		background-color: #ebedf5;
		font-weight: 600;
		color: #4e596a;
	}
}

.powerText {
	font-family: PingFangSC-Regular;
	font-size: 14px;
	font-weight: normal;
	color: #4e596a;
	margin-left: 5px;
	position: relative;
	top: 1px;
}

.mr-38 {
	margin-right: 38px;
}
</style>
